import { render, staticRenderFns } from "./SharedMediaFolderInfo.vue?vue&type=template&id=f434fc52&"
import script from "./SharedMediaFolderInfo.vue?vue&type=script&lang=js&"
export * from "./SharedMediaFolderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports